import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { useAuth } from '../../hooks/useAuth'
import { calcularTotalItemSinIva } from '../helpers/calcularPrecioTotal'
import Vendedor from './Vendedor'

const PasarelaPago = ({ itemsCompra }) => {
  const { loginDataContext: { idUsuario } = {} } = useAuth()
  const [comprasPorPagar, setComprasPorPagar] = useState([])

  useEffect(() => {
    const arrVendedores = []
    const uniqueVendedores = [...new Set(itemsCompra.map((item) => item.idVendedor))]

    uniqueVendedores.forEach((idVendedor) => {
      const pedidoItems = itemsCompra.filter((item) => item.idVendedor === idVendedor)

      const totalAPagar = pedidoItems.reduce((total, item) => {
        if (item.valorTotalSinIva) {
          return total + Number(item.valorTotalSinIva)
        }

        if (item.precioUnitario) {
          return total + calcularTotalItemSinIva(item)
        }

        const base = Number(item.precioUnitario) || 0
        const porc = Number(item.porcDcto) || 0
        const factor = porc > 0 && porc < 100 ? 1 - porc / 100 : 1
        const precioEfectivo = base * factor
        const cant = Number(item.cantidad) || 1

        return total + precioEfectivo * cant
      }, 0)

      arrVendedores.push({
        idComprador: idUsuario,
        idVendedor,
        empidVendedor: pedidoItems[0].empid,
        razonSocial: pedidoItems[0].razonSocial,
        calle: pedidoItems[0].calle,
        altura: pedidoItems[0].altura,
        celular: pedidoItems[0].celular,
        email: pedidoItems[0].email,
        telefono: pedidoItems[0].telefono,
        pedidoItems,
        totalAPagar
      })
    })
    setComprasPorPagar(arrVendedores)
  }, [itemsCompra, idUsuario])

  return comprasPorPagar.map((vendedor) => (
    <Vendedor key={vendedor.idVendedor} vendedor={vendedor} />
  ))
}

PasarelaPago.propTypes = {
  itemsCompra: PropTypes.array.isRequired
}

export default PasarelaPago
